import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'

import VueMask from 'v-mask'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import './assets/layouts/index.css'

Vue.config.productionTip = false

Vue.use(VueMask);
Vue.use(VueAwesomeSwiper)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
